import { useEffect, useMemo, useRef, useState } from 'react'

export const buildSearchOptions = (identifierValue, identifierLabel) => [
  { value: 'client', name: 'Client' },
  { value: 'insurance', name: 'Insurance' },
  { value: identifierValue, name: identifierLabel },
  { value: 'ro', name: 'RO #' },
  { value: 'vehicle', name: 'Vehicle' },
  { value: 'vin', name: 'VIN' }
]

export const useSearchFilters = ({ identifierValue, identifierLabel, debounceMs = 1000, onFiltersChange }) => {
  const [primarySearchBy, setPrimarySearchBy] = useState('ro')
  const [primaryQuery, setPrimaryQuery] = useState('')
  const [secondarySearchBy, setSecondarySearchBy] = useState('vin')
  const [secondaryQuery, setSecondaryQuery] = useState('')
  const [searchFilters, setSearchFilters] = useState([])
  const onFiltersChangeRef = useRef(onFiltersChange)
  const lastFiltersRef = useRef([])

  const searchOptions = useMemo(() => buildSearchOptions(identifierValue, identifierLabel), [identifierLabel, identifierValue])

  useEffect(() => {
    onFiltersChangeRef.current = onFiltersChange
  }, [onFiltersChange])

  useEffect(() => {
    const performSearch = () => {
      const trimmedPrimaryQuery = primaryQuery.trim()
      const trimmedSecondaryQuery = secondaryQuery.trim()
      const updatedSearchFilters = [
        ...(trimmedPrimaryQuery ? [{ column: primarySearchBy, value: [trimmedPrimaryQuery] }] : []),
        ...(trimmedSecondaryQuery ? [{ column: secondarySearchBy, value: [trimmedSecondaryQuery] }] : [])
      ]

      if (JSON.stringify(lastFiltersRef.current) === JSON.stringify(updatedSearchFilters)) {
        return
      }
      lastFiltersRef.current = updatedSearchFilters
      setSearchFilters(updatedSearchFilters)
      onFiltersChangeRef.current?.(updatedSearchFilters)
    }

    const timeoutId = setTimeout(performSearch, debounceMs)
    return () => clearTimeout(timeoutId)
  }, [debounceMs, primaryQuery, primarySearchBy, secondaryQuery, secondarySearchBy])

  return {
    primarySearchBy,
    setPrimarySearchBy,
    primaryQuery,
    setPrimaryQuery,
    secondarySearchBy,
    setSecondarySearchBy,
    secondaryQuery,
    setSecondaryQuery,
    searchFilters,
    searchOptions
  }
}
